import { Box, Container, Typography } from '@mui/material';

import Footer from '@components/Footer';
import Header from '@components/Header';

import { useStyles } from './useStyles';

const AccessibilityStatement = () => {
  const classes = useStyles();
  return (
    <Box className={classes.mainContainer}>
      <Header />
      <Container maxWidth="xl" disableGutters>
        <Box className={classes.container}>
          <Typography variant="h1" color="cinnamon.main" align="center">
            Accessibility statement
          </Typography>
          <Typography variant="body2" align="left" color="garamMasala.main">
            The Cumin Club is committed to making our website's content
            accessible and user friendly to everyone. If you are having
            difficulty viewing or navigating the content on this website, or
            notice any content, feature, or functionality that you believe is
            not fully accessible to people with disabilities, please email our
            Customer Service team at{' '}
            <a
              href="mailto:hello@thecuminclub.com"
              style={{
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
            >
              hello@thecuminclub.com
            </a>{' '}
            with “Accessibility Inquiry” in the subject line and provide a
            description of the specific feature you feel is not fully accessible
            or a suggestion for improvement. We take your feedback seriously and
            will consider it as we evaluate ways to accommodate all of our
            customers and our overall accessibility policies. Additionally,
            while we do not control such vendors, we strongly encourage vendors
            of third-party digital content to provide content that is accessible
            and user friendly.
          </Typography>
        </Box>
      </Container>
      <Footer />
    </Box>
  );
};

export default AccessibilityStatement;
